export var disableBackdropClick = false;
export var disableEscapeKeyDown = false;
export var disablePhysicalBackAndroid = false;